import React from 'react'
import { Modal, Form, Input } from 'antd';

const CreateTeamModal = ({ dataProps }) => {
  const { open, setOpen, actions } = dataProps;
  const [form] = Form.useForm();

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        console.log('Form values:', values);
        actions.handleCreateTeam(values?.teamTitle)
        form.resetFields();
        setOpen(false);
      })
      .catch((errorInfo) => {
        console.log('Validation failed:', errorInfo);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    setOpen(false);
  };

  return (
    <div>
      <Modal
        title="Create Department"
        open={open}
        onOk={handleOk}
        okText="Create"
        onCancel={handleCancel}
      >
        <Form form={form} layout="vertical" name="basicForm">
          <Form.Item
            label="Department Name"
            name="teamTitle"
            rules={[
              {
                validator: (_, value) => {
                  if (!value || value.trim() === "" || value.startsWith(" ")) {
                    return Promise.reject(new Error("Department name cannot be empty or start with a space!"));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input placeholder="Enter Department Name" />
          </Form.Item>


        </Form>
      </Modal>
    </div>
  )
}

export default CreateTeamModal;